import { OutboundLink } from 'react-ga'
import PropTypes from 'prop-types'
import whatnot320x50_1 from '../assets/ads/whatnot320x50_1.png'
import whatnot320x50_2 from '../assets/ads/whatnot320x50_2.png'
import whatnot970x250_1 from '../assets/ads/whatnot970x250_1.png'
import whatnot970x250_2 from '../assets/ads/whatnot970x250_2.png'

const Ad = ({ suffix }) => {
  if (suffix === 1) {
    return (
      <OutboundLink
        eventLabel='https://whatnot.onelink.me/zALw/y21g2trg'
        rel='noopener noreferrer'
        target='_blank'
        to='https://whatnot.onelink.me/zALw/y21g2trg'
      >
        <img
          alt='Whatnot'
          className='d-block d-sm-none'
          src={whatnot320x50_1}
        />
        <img
          alt='Whatnot'
          className='d-none d-sm-block'
          src={whatnot970x250_1}
        />
      </OutboundLink>
    )
  } else if (suffix === 2) {
    return (
      <OutboundLink
        eventLabel='https://whatnot.onelink.me/zALw/y21g2trg'
        rel='noopener noreferrer'
        target='_blank'
        to='https://whatnot.onelink.me/zALw/y21g2trg'
      >
        <img
          alt='Whatnot'
          className='d-block d-sm-none'
          src={whatnot320x50_2}
        />
        <img
          alt='Whatnot'
          className='d-none d-sm-block'
          src={whatnot970x250_2}
        />
      </OutboundLink>
    )
  }
}

Ad.propTypes = {
  className: PropTypes.string,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
}

export default Ad
